import { el } from 'redom';

import './index.scss';

class CircleProgressBar {

  constructor(configuration) {
    this.progress = configuration.progress || 0;

    this.el = el('div.circle-progress-bar-main', [

    ]);

    // this.progressCircle = this.el.querySelectorAll('circle')[1];
    this.set(this.progress);
  }

  set(progress) {

    this.progress = progress;

    this.el.textContent = `${progress}%`;

  }
}

export default CircleProgressBar;